<template>
  <div>
    <div> 
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Expenses</b-navbar-brand>
        </b-navbar>

        <banner-component
          :allModuleIdBanner="
            this.$sessionsStorage.get('allModuleIdMain')
              ? this.$sessionsStorage.get('allModuleIdMain')
              : ''
          "
          :jobSeriesBanner="
            this.$sessionsStorage.get('JOBSERIES')
              ? this.$sessionsStorage.get('JOBSERIES')
              : ''
          "
          :bannerClientName="
            assignmentData[0].clientName ? assignmentData[0].clientName : ''
          "
          iconId="fa fa-ship"
        />
        <!-- :bannerClientName="ImportDetail.clientName ? ImportDetail.clientName : ''" -->
        <b-card class="formCard">
          <b-card-text>
            <div>
              <div
                class="mt-4"
                v-if="
                  (INVDetail.exp_id != '' && accounts == false) ||
                  (INVDetail.exp_id != '' && role == 'Admin')
                "
              >
                <!-- checkbox-1 -->
                <input
                  :id="'revcheckbox'"
                  name="checkbox-1"
                  type="checkbox"
                  v-model="INVDetail.revisedMail"
                  @click="RevisedAss('revcheckbox')"
                  value="1"
                  unchecked-value="0"
                />
                <span class="error">Send Revised Expenses Request</span>
              </div>

              <hr />
              <!-- // Drag And Drop Section Start -->
              <!-- v-if="!item.doc_id" -->
              <!-- v-if="!item.doc_id" -->
              <b-row class="ml-0 mr-0">
                <b-col md="6">
                  <h5>
                    <b-badge class="ml-2" variant="info">Assignment Details</b-badge>
                  </h5>
                  <b-table
                    show-empty
                    stacked="md"
                    :items="assignmentData"
                    :fields="assignmentFields"
                    responsive
                    class="position-relative"
                  >
                    <template slot="Job_Series" slot-scope="row1">
                      <span>{{
                        row1.item.Job_Series != "" ? row1.item.Job_Series : "--"
                      }}</span>
                    </template>
                    <template slot="JobDate" slot-scope="row2">
                      <span>{{
                        row2.item.JobDate != "" ? row2.item.JobDate : "--"
                      }}</span>
                    </template>
                    <template slot="clientName" slot-scope="row3">
                      <span>{{
                        row3.item.clientName != "" ? row3.item.clientName : "--"
                      }}</span>
                    </template>
                    <template slot="POD" slot-scope="row4">
                      <span>{{ row4.item.POD != "" ? row4.item.POD : "--" }}</span>
                    </template>
                  </b-table>
                  <!-- <table id="otherAdditionalTask" class="table table-bordered table-sm ">
                    <tbody>
                      <tr>
                        <th>Job No.</th>
                        <th>Job Date</th>
                        <th>Client Name</th>
                        <th>POD</th>
                      </tr>

                      <tr v-for="(item, index) in assignmentData" :key="index">
                        <td class="error" style="font-size: 12px">
                          {{ item.Job_Series }}
                        </td>
                        <td class="error" style="font-size: 12px">{{ item.JobDate }}</td>
                        <td class="error" style="font-size: 12px">
                          {{ item.clientName }}
                        </td>
                        <td class="error" style="font-size: 12px">{{ item.POD }}</td>
                      </tr>
                    </tbody>
                  </table> -->
                </b-col>
                <b-col md="6">
                  <h5>
                    <b-badge variant="info">Expense Document Details</b-badge>
                  </h5>
                  <b-table
                    show-empty
                    stacked="md"
                    :items="ExpenseData"
                    :fields="ExpenseDocumentFields"
                    responsive
                    class="position-relative"
                  >
                    <template slot="expenseDate" slot-scope="row1">
                      <span>{{
                        row1.item.expenseDate != "" ? row1.item.expenseDate : "--"
                      }}</span>
                    </template>
                    <template slot="documentLink" slot-scope="row2">
                      <a
                        style="color: blue"
                        v-if="row2.item.documentLink"
                        href="javascript:void(0)" @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${assignmentData[0].Job_Series.replaceAll('/', '_')}/${row2.item.documentLink.replaceAll('/', '_')}`)"
                        ><b
                          ><u>View</u></b>
                          <!-- <u>{{ row2.item.otherDocName }}</u> -->
                        </a
                      >
                    </template>
                  </b-table>
                  <!-- <table id="otherAdditionalTask" class="table table-bordered table-sm">
                    <tbody>
                      <tr>
                        <th>Expense Date</th>
                        <th>View</th>
                      </tr>

                      <tr v-for="(item, index) in ExpenseData" :key="index">
                        <td>
                          <h6>{{ item.expenseDate }}</h6>
                        </td>
                        <td>
                          <h6>
                            <a
                              style="color: blue"
                              v-if="item.documentLink"
                              :href="
                                `${docURL}/ASSIGNMENT_UPLOADS/` +
                                assignmentData[0].Job_Series.replaceAll('/', '_') +
                                `/` +
                                item.documentLink.replaceAll('/', '_')
                              "
                              target="_blank"
                              download
                              ><b
                                ><u>{{ item.otherDocName }}</u></b
                              ></a
                            >
                          </h6>
                        </td>
                      </tr>
                      <tr v-if="ExpenseData.length <= 0">
                        <td colspan="2" style="text-align: center; color: red">
                          <b>NO Expense Document ADDED</b>
                        </td>
                      </tr>
                    </tbody>
                  </table> -->
                </b-col>
              </b-row>
              <b-row align-v="start">
                <b-col md="6">
                  <!-- {{ "PS" + fileuploaded+singleUpload+"SS" }} -->
                  <multi-file-uploader
                    :style="'height: 80px; background: darkgray; width: 100%'"
                    :documentName="'Expense_Multiple_Doc-'"
                    :otherDocName="'Expense_Multiple_Doc-'"
                    :folderName="'Expense'"
                    :accept="'*'"
                    :assign_no="assignmentData[0].Job_Series"
                    :multiple="true"
                    v-model="singleUpload"
                    :state="Boolean(singleUpload)"
                    :fileAllModuleId="$sessionsStorage.get('allModuleIdMain')"
                  ></multi-file-uploader>
                  <!-- <b-form-file
                    style="height: 200px; background: darkgray; width: 900px"
                    multiple
                    v-model="singleUpload"
                    :state="Boolean(singleUpload)"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    plain
                  ></b-form-file>
                  <span>Choose a file or drop it above...</span>
                  <br /> -->
                  <span class="error" v-if="files_err ? true : false">{{
                    files_err
                  }}</span>
                </b-col>
                <b-col md="6">
                  <label>Nature Of Expense<span class="error">*</span></label>

                  <model-list-select 
                    :list="natureOfExpenseList"
                    @input="getNatureOfExpenseTitile()"
                    option-value="label"
                    option-text="label" v-model="nature_of_expense" placeholder="Select Nature Of Expense" :style="{
                    borderColor:(!nature_of_expense && nature_of_expense_err) ? 'red' : '',}"
                  />
                  <span class="error" v-if="nature_of_expense_err">{{ nature_of_expense_err }}</span>

                </b-col>
                <b-col md="6"></b-col>
                  <b-col md="6">
                  <label>Remark <span class="error">*</span></label>
                  <b-form-textarea
                    :formatter="capitalizeAll"
                    name="DocRemark"
                    id="DocRemark"
                    v-model="docRemark"
                    rows="6"
                  ></b-form-textarea>
                  <span class="error" v-if="docRemark_err">{{ docRemark_err }}</span>
                </b-col>
                
                <!-- <b-col md="6"></b-col> -->
                <b-col md="12" class="text-right">
                  <b-button
                    class="mt-3"
                    variant="primary"
                    id="addButtonLoaderSB"
                    @click="adddragfilesINVDetail"
                    :disabled="
                      assignmentData[0].Job_Series != $sessionsStorage.get('JOBSERIES') ||
                      singleUpload == ''
                        ? true
                        : false
                    "
                    >Save & Submit
                  </b-button>

                  <md-spinner
                    md-indeterminate
                    id="loaderSB"
                    style="display: none"
                  ></md-spinner>
                </b-col>
              </b-row>

              <!-- <b-form-file
                :files="files"
                multiple
                @change="handleChange"
              ></b-form-file>
              <span class="error" v-if="files_err ? true : false">{{
                files_err
              }}</span> -->
              <!-- @change="handleChange" -->
              <!-- @selected="onFileChangeExpense_Multiple_Doc('Sline_Invoice')" -->
              <!-- @change="handleChange" -->
              <!-- :file-name-formatter="formatNames" -->
              <!-- // Drag And Drop Section End -->

              <!-- <b-button
                id="show-btn"
                size="sm"
                variant="outline-primary"
                @click="addInvArry"
              >
                Add Expenses <i class="fa fa-plus" aria-hidden="true"></i
              ></b-button> -->
              <b-card class="mt-2" v-for="(itm, idx) in lineInvModalArray" :key="idx">
                <div class="d-flex align-items-center" v-if="idx != 0">
                  <b-button
                    class="ml-auto"
                    id="show-btn"
                    size="sm"
                    variant="danger"
                    @click="removeInvArry(idx)"
                  >
                    Remove Expenses <i class="fa fa-plus" aria-hidden="true"></i
                  ></b-button>
                </div>

                <div class="mt-2" v-if="INVDetail.revisedMail != 0">
                  <input
                    :disabled="
                      itm.invPayStatus == 2 || itm.invPayStatus == 1 ? true : false
                    "
                    :id="'checkbox-' + idx"
                    type="checkbox"
                    @click="addRevisedInvoice(idx, 'checkbox-' + idx)"
                  />
                  <span class="error">Revise Expenses</span>
                </div>

                <b-row align-v="start">
                  <b-col cols="3">
                    <label for="refuelStationId"
                      >Vendor <span class="error">*</span></label
                    >
                    <model-list-select
                      :list="getVendorData"
                      id="refuelStationId"
                      :isDisabled="accounts == true && role != 'Admin' ? true : false"
                      v-model="itm.vendor"
                      option-value="refuelStationId"
                      option-text="vendorName"
                      placeholder="Select Vendor Name"
                      @input="onSelectVendor(idx, itm, itm.vendor)"
                    ></model-list-select>
                    <b-form-input
                      v-if="itm.otherVendorFlag != false"
                      :formatter="capitalizeAll"
                      :disabled="accounts == true && role != 'Admin' ? true : false"
                      class="mt-2"
                      name="otherVendor"
                      id="otherVendor"
                      v-model="itm.otherVendor"
                    ></b-form-input>
                    <!-- <span class="error" v-if="itm.vendor_err ? true : false">{{
                      itm.vendor_err
                    }}</span> -->
                  </b-col>
                  <b-col cols="3"
                    ><label>Invoice Type <span class="error">*</span> </label>
                    <model-list-select
                      multiple="true"
                      :isDisabled="accounts == true && role != 'Admin' ? true : false"
                      :list="invoiceTypeList"
                      v-model="itm.invType"
                      option-value="value"
                      option-text="text"
                      placeholder="Select Invoice Type"
                    >
                    </model-list-select>
                    <span class="error" v-if="itm.invType_err ? true : false">{{
                      itm.invType_err
                    }}</span>
                  </b-col>
                  <b-col cols="3"
                    ><label>Invoice No <span class="error">*</span></label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      :disabled="accounts == true && role != 'Admin' ? true : false"
                      name="InvoiceNo"
                      id="InvoiceNo"
                      v-model="itm.invNo"
                    ></b-form-input>
                    <span class="error" v-if="itm.invNo_err">{{ itm.invNo_err }}</span>
                  </b-col>
                  <b-col cols="3"
                    ><label>Invoice Date <span class="error">*</span></label
                    ><br />
                    <date-picker
                      :disabled="accounts == true && role != 'Admin' ? true : false"
                      :format="selectDateFormat"
                      lang="en"
                      name="InvoiceDate"
                      id="InvoiceDate"
                      v-model="itm.invDate"
                      :minute-step="1"
                      @input="onChooseInvoiceDate($event, itm)"
                    ></date-picker>
                    <span class="error" v-if="itm.invDate_err">{{
                      itm.invDate_err
                    }}</span>
                  </b-col>
                  <b-col cols="3"
                    ><label>Invoice Amount <span class="error">*</span></label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      :disabled="accounts == true && role != 'Admin' ? true : false"
                      type="number"
                      name="InvoiceAmount"
                      id="InvoiceAmount"
                      v-model="itm.invAmount"
                    ></b-form-input>
                    <span class="error" v-if="itm.invAmount_err">{{
                      itm.invAmount_err
                    }}</span>
                  </b-col>
                  <b-col cols="3"
                    ><label>Currency <span class="error">*</span></label>
                    <model-list-select
                      :isDisabled="accounts == true && role != 'Admin' ? true : false"
                      :list="currList"
                      v-model="itm.invCurrency"
                      option-value="payVal"
                      option-text="payText"
                      placeholder="Select Currency"
                    >
                    </model-list-select>
                    <span class="error" v-if="itm.invCurrency_err">{{
                      itm.invCurrency_err
                    }}</span>
                  </b-col>
                  <b-col cols="3"
                    ><label>Remarks</label>
                    <b-form-textarea
                      :formatter="capitalizeAll"
                      :disabled="accounts == true && role != 'Admin' ? true : false"
                      name="shippingBillNo"
                      id="shippingBillNo"
                      v-model="itm.invRemarks"
                    >
                    </b-form-textarea>
                  </b-col>
                  <b-col cols="6">
                    <md-input-container>
                      <label>Invoice Documents <span class="error">*</span></label>
                      <md-file
                        :disabled="accounts == true && role != 'Admin' ? true : false"
                        name="invoiceUpload"
                        id="invoiceUpload"
                        v-model="itm.invSlineUpload"
                        @selected="onFileChangeBlDraft('Sline_Invoice', idx)"
                      >
                      </md-file>
                    </md-input-container>
                    <span class="error" v-if="itm.invSlineUpload_err">{{
                      itm.invSlineUpload_err
                    }}</span>
                    <md-layout v-if="viewInvDoc.length > 0" md-gutter class="gutr">
                      <md-layout
                        md-flex="40"
                        v-for="(item, index) in viewInvDoc"
                        :key="index"
                      >
                        <a
                          v-if="assign_no_series"
                          href="javascript:void(0)" @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${doc_path}/${item.replaceAll('/', '_')}`)"
                          >--View Document - {{ index + 1 }}</a
                        >
                      </md-layout>
                    </md-layout>
                  </b-col>
                  <!-- <br /> -->
                  <!-- <div v-if="viewInvDoc.length > 0">
                    <md-layout  v-if="viewInvDoc.length > 0" md-gutter class="gutr">
                      <md-layout
                        md-flex="40"
                        v-for="(item, index) in viewInvDoc"
                        :key="index"
                      >
                        <a
                          v-if="assign_no_series"
                          :href="
                            `${docURL}/ASSIGNMENT_UPLOADS/` +
                            doc_path +
                            '/' +
                            item
                          "
                          target="_blank"
                          download
                          >--View Document - {{ index + 1 }}</a
                        >
                      </md-layout>
                    </md-layout>
                  </div> -->

                  <b-col
                    cols="3"
                    v-if="
                      (INVDetail.exp_id != '' && accounts == true) ||
                      (INVDetail.exp_id != '' && role == 'Admin')
                    "
                  >
                    <label>Payment Mode</label>
                    <model-list-select
                      :isDisabled="accounts != true && role != 'Admin' ? true : false"
                      :list="payList"
                      v-model="itm.invPayMode"
                      option-value="payVal"
                      option-text="payText"
                      placeholder="Select Payment Mode"
                      @input="onSelectPaymentMode($event, itm)"
                    ></model-list-select>
                    <span class="error" v-if="itm.invPayMode_err ? true : false">{{
                      itm.invPayMode_err
                    }}</span>
                  </b-col>
                  <b-col
                    cols="3"
                    v-if="
                      (INVDetail.exp_id != '' && accounts == true) ||
                      (INVDetail.exp_id != '' && role == 'Admin')
                    "
                    ><label>Payment Ref</label>
                    <b-form-input
                      :disabled="accounts != true && role != 'Admin' ? true : false"
                      :formatter="capitalizeAll"
                      name="PaymentRef"
                      id="PaymentRef"
                      v-model="itm.invPayRef"
                    ></b-form-input>
                    <span class="error" v-if="itm.invPayRef_err ? true : false">{{
                      itm.invPayRef_err
                    }}</span>
                  </b-col>
                  <b-col
                    cols="3"
                    v-if="
                      (INVDetail.exp_id != '' && accounts == true) ||
                      (INVDetail.exp_id != '' && role == 'Admin')
                    "
                    ><label>Payment Amount</label>
                    <b-form-input
                      :disabled="accounts != true && role != 'Admin' ? true : false"
                      :formatter="capitalizeAll"
                      name="PaymentAmount"
                      id="PaymentAmount"
                      v-model="itm.invPaidAmount"
                    ></b-form-input>
                    <!-- type="number" -->
                    <span class="error" v-if="itm.invPaidAmount_err ? true : false">{{
                      itm.invPaidAmount_err
                    }}</span>
                  </b-col>
                  <b-col
                    cols="3"
                    v-if="
                      (INVDetail.exp_id != '' && accounts == true) ||
                      (INVDetail.exp_id != '' && role == 'Admin')
                    "
                    ><label>Payment Date</label>
                    <date-picker
                      :disabled="accounts != true && role != 'Admin' ? true : false"
                      :format="selectDateFormat"
                      lang="en"
                      name="PaymentDate"
                      id="PaymentDate"
                      v-model="itm.invPayDate"
                      :minute-step="1"
                      @input="onChoosePaymentDate($event, itm)"
                    >
                    </date-picker>

                    <span class="error" v-if="itm.invPayDate_err ? true : false">{{
                      itm.invPayDate_err
                    }}</span>
                  </b-col>
                  <b-col
                    cols="3"
                    v-if="
                      (INVDetail.exp_id != '' && accounts == true) ||
                      (INVDetail.exp_id != '' && role == 'Admin')
                    "
                    ><label>Payment Status</label>
                    <model-list-select
                      :isDisabled="accounts != true && role != 'Admin' ? true : false"
                      :list="statusList"
                      v-model="itm.invPayStatus"
                      option-value="payVal"
                      option-text="payText"
                      placeholder="Select Payment Status"
                      @input="onSelectPaymentStatus($event, itm)"
                    ></model-list-select>
                    <span class="error" v-if="itm.invPayStatus_err ? true : false">{{
                      itm.invPayStatus_err
                    }}</span>
                  </b-col>
                </b-row>
              </b-card>

              <md-layout md-gutter class="gutr center">
                <md-layout md-flex="100">
                  <b-button
                    v-if="lineInvModalArray.length > 0"
                    class="mt-3"
                    variant="primary"
                    id="addButtonLoaderSB"
                    @click="addINVDetail"
                    >Save & Submit
                  </b-button>

                
                </md-layout>
              </md-layout>
            </div>
          </b-card-text>
        </b-card>

        <md-dialog-confirm
          :md-content-html="alert.content"
          :md-ok-text="alert.ok"
          ref="popMailAfter"
        ></md-dialog-confirm>

        <md-dialog-confirm
          :md-content-html="alert.content"
          :md-ok-text="alert.ok"
          ref="addPop"
        ></md-dialog-confirm>
      </b-card-text>
    </b-card>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import Multiselect from "vue-multiselect";

import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import MultiFileUploader from "../common/MultiFileUploader.vue";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";

export default {
  // props: ["allModuleId", "JOBSERIES"],
  beforeMount() {
    //  alert(this.$sessionsStorage.get("allModuleIdMain"));
    //  alert(this.$sessionsStorage.get("JOBSERIES"));
    //     globalPermissionStatus("Accounts") &&
    // this.$sessionsStorage.get("allModuleIdMain") != undefined &&
    // this.$sessionsStorage.get("JOBSERIES") != ""
    this.getAllNatureOfExpense();
    if (
      this.$sessionsStorage.get("allModuleIdMain") != undefined &&
      this.$sessionsStorage.get("JOBSERIES") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/allModule/Expenses");
      if (this.$sessionsStorage.get("allModuleIdMain")) {
        this.getData();
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },

  data() {
    return {
      assignmentData: [],
      ExpenseData: [],
      singleUpload: [],
      docRemark: "",
      docRemark_err: "",
      nature_id: "",
      nature_of_expense:"",
      nature_of_expense_err:"",
      docArray: [
        {
          documentName: "",
          documentLink: "",
          docRemarks: "",
          addedFromMain: "5",
          allModuleId: this.$sessionsStorage.get("allModuleIdMain"),
        },
      ],
      files: [],
      files_err: "",
      err_flag: false,
      assign_no_series: this.$sessionsStorage.get("JOBSERIES"),
      allModuleId: this.$sessionsStorage.get("allModuleIdMain"),
      doc_path: "",
      syncFlag: false,
      invnoErrFlag: false,
      selectDateFormat,
      accounts: globalPermissionStatus("Accounts"),
      invBlDraftUpload: "",
      componentKey: 0,
      revisedInvoiceDetails: [],
      selectedInvoice: [],
      items: [],
      lastSelectItem: {},
      getVendorData: ["gfdg"],
      natureOfExpenseList:
       [
        // {
        //   payVal: "AGENT INVOICE",
        //   payText: "AGENT INVOICE",
        // },
        // {
        //   payVal: "IFS INVOICE",
        //   payText: "IFS INVOICE",
        // },
        // {
        //   payVal: "CFS INVOICE",
        //   payText: "CFS INVOICE",
        // },
        // {
        //   payVal: "RAIL FREIGHT",
        //   payText: "RAIL FREIGHT",
        // },

        // {
        //   payVal: "HC RECEIPT",
        //   payText: "HC RECEIPT",
        // },
        // {
        //   payVal: "RECEIPTED EXPENSES",
        //   payText: "RECEIPTED EXPENSES",
        // },
        // {
        //   payVal: "CERTIFICATE EXPENSES",
        //   payText: "CERTIFICATE EXPENSES",
        // },
      ],
      payList: [
        {
          payVal: "1",
          payText: "RTGS",
        },
        {
          payVal: "2",
          payText: "Cheque",
        },
      ],
      statusList: [
        // {
        //   payVal: "1",
        //   payText: "PARTIAL",
        // },
        {
          payVal: "2",
          payText: "COMPLETED",
        },
      ],
      currList: [
        {
          payVal: "INR",
          payText: "INR",
        },
        {
          payVal: "USD",
          payText: "USD",
        },
      ],
      invCategoryList: [
        {
          payVal: "Supplementary",
          payText: "Supplementary",
        },
        {
          payVal: "Normal",
          payText: "Normal",
        },
      ],
      invoiceTypeList: [
        {
          value: "Vendor Expenses",
          text: "Vendor Expenses",
        },
        {
          value: "Fuel Expenses",
          text: "Fuel Expenses",
        },
        {
          value: "Transportation Outsource",
          text: "Transportation Outsource",
        },
        {
          value: "CFS Expenses",
          text: "CFS Expenses",
        },
        {
          value: "ICD Expenses",
          text: "ICD Expenses",
        },
        {
          value: "Railout Expenses",
          text: "Railout Expenses",
        },
        {
          value: "Others Expenses",
          text: "Others Expenses",
        },
      ],
      assignmentFields: [
        {
          key: "Job_Series",
          label: "Job No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "JobDate",
          label: "Job Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "clientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "POD",
          label: "POD",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      ExpenseDocumentFields: [
        {
          key: "expenseDate",
          label: "Expense",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "nature_of_expense",
          label: "Nature Of Expense",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "documentLink",
          label: "View",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      showAlgo: false,
      algoConNo: "",
      docURL: URL_BASE_DOC,
      isLoading: false,
      value12: "",
      CCdone: "",
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      INVDetail: {
        moduleType: "",
        revisedMail: "0",
        dueDate: "",
        invoiceAmount: "",
        sobDate: "",
        doc_path_series: "",
        allModuleId: "",
        paymentDone: "",
        userId: "",
        slineInvoice: "",
        exp_id: "",

        paymentMode: "",
        totalAmount: "",
        payRefNumber: "",
        payDate: "",
        salesExeuctionNo: "",
      },

      errorINVExecution: [],
      arrayINVExecutionError: [
        "Invoice Type Field Required",
        "Invoice No Field Required",
        "Invoice Amount Field Required",
        "Currency Field Required",
        "Invoice Documents Field Required",
      ],
      errorAtleastSb: "",
      errorAtleastContainer: "",

      permissionStatus: true,
      invDetailArray: [],
      showMoreSB: false,

      role: this.$sessionsStorage.get("designation"),
      packageNameList: [],
      nextPageType: "",

      editIndex: "",
      deleteId: "",
      showDivCountNote: false,
      lineInvModalArray: [],

      validateTrans: true,
      validateINV: true,
    };
  },
  created() {
    // EventBus.$on("file-selected", (file) => {
    //   this.selectedFile = file;
    // });
    eventBus.$on("fileuploaded", (file) => {
      console.log("fileuploaded=>", file);
      this.singleUpload = file;
    });
  },

  mounted() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    MultiSelect,
    // Loading,
     CustomLoader,
    BannerComponent,
    Multiselect,
    MultiFileUploader,
  },
  computed: {
    disableSave() {
      return this.accounts == false && this.role != "Admin" && !this.INVDetail.exp_id
        ? true
        : false;
    },
    viewInvDoc() {
      // alert(this.assign_no_series);
      // alert(this.assign_no_series.replaceAll('/', '_'));
      return this.INVDetail.slineInvoice != ""
        ? this.INVDetail.slineInvoice.split(",")
        : [];
    },

    viewSlineInvDoc() {
      return this.INVDetail.slineInvoice != ""
        ? this.INVDetail.slineInvoice.split(",")
        : [];
    },
    invDetailArrayList() {
      return this.invDetailArray;
    },
    masterList() {
      return this.getLocationList;
    },
  },
  methods: {
    // Drag And Drop Section Start
    // onFileChangeExpense_Multiple_Doc('Expense_Multiple_Doc')
    getNatureOfExpenseTitile() {
      let Arr=this.natureOfExpenseList.filter((x) => {
        return x.label == this.nature_of_expense;
      });
      console.log('Arr=>',Arr)
      if(Arr.length>0){
        this.nature_id = Arr[0].nature_id;
        this.nature_of_expense = Arr[0].label;
      }
      console.log('Arr=>',Arr)
    },
    getAllNatureOfExpense(){
      let payload = {isSelectedColumn:1,isAll:1};
      NodeLockPannelService.getNatureOfExpense(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log('BrfBookingList', data)
            if (status == 200 && data) {
              
            if (data.data.length > 0) {
              this.natureOfExpenseList = data.data;
            }
              
            }
            this.isLoading = false;
          })
          .catch((error) => {
            this.isSubmited = false;
            console.log("Catch on getNatureOfExpense Error: ", error);
          });
    },
    onFileChangeExpense_Multiple_Doc(index = 0, item) {
      console.log("My Item=>", item);
      var files = this.singleUpload;
      console.log("singleUpload-Happy", this.singleUpload);
      let assign_no = this.$sessionsStorage.get("JOBSERIES");
      let ModuleID = this.$sessionsStorage.get("allModuleIdMain");
      var formData = new FormData();
      let item_new = [];
      for (let i = 0; i < files.length; i++) {
        let obj = {
          documentName: "Expense_Multiple_Doc-" + this.singleUpload.length + "_" + i,
          otherDocName: "Expense_Multiple_Doc-" + this.singleUpload.length + "_" + i,
          documentLink: files[i].name,
          docRemarks: this.docRemark,
          addedFromMain: "5",
          allModuleId: ModuleID,
          assign_no: assign_no,
        };
        item_new.push(obj);
        formData.append("file[]", files[i]);
        formData.append(
          "staticFileName",
          "Expense_Multiple_Doc-" + this.singleUpload.length + "_" + i
        );
        formData.append("upload_dir_folderName", assign_no.replaceAll("/", "_"));
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          this.docArray[index].singleUpload = result.data;
          let New_generated_file = result.data;
          // this.isLoading = false;
          this.submitDocment(item_new, New_generated_file);
        })
        .catch((err) => {
          throw err;
        });
    },
    submitDocment(item_new, New_generated_file) {
      let splitAssignMentId = "";

      let assign_no = this.$sessionsStorage.get("JOBSERIES");
      let ModuleID = this.$sessionsStorage.get("allModuleIdMain");

      if (assign_no) {
        let abc = assign_no.split("/");
        if (abc.length > 0) {
          item_new["splitAssignMentId"] = abc[5];
        }
      }
      let mydoc = {
        item_new: item_new,
        New_generated_file: New_generated_file,
        nature_of_expense:this.nature_of_expense,
        nature_id:this.nature_id,
      };
      this.showAdd = true;
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Expenses/uploadFileExpenseModuleForAll.php`,
        // url: `${URL_BASE}/uploadFileExpenseModuleForAll.php`,
        data: JSON.stringify(mydoc),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json,multipart/form-data",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200) {
            $("#loaderSB").css("display", "none");
            $("#addButtonLoaderSB").css("display", "block");

            this.alert.content = data.msg;
            this.$refs["addPop"].open();

            this.singleUpload = [];
            this.getData();
          }
        })
        .catch((error) => {});
    },
    validatedragfilesINVDetail() {
      let validate_new = true;
      // alert(this.files.length);singleUpload
      console.log("MyFiles=>", this.files);
      // if (this.files.length <= 0) {
      //   this.files_err = "Files Field is Required";
      //   validate_new = false;
      // } else {
      //   this.files_err = "";
      //   validate_new = true;
      // }

      if (this.singleUpload.length <= 0) {
        this.files_err = "Files Field is Required";
        validate_new = false;
      } else {
        this.files_err = "";
        validate_new = true;
      }

      if (validate_new == false) {
        this.validateINV = false;
      } else {
        this.validateINV = true;
      }
    },
    adddragfilesINVDetail() {
      let assign_no = this.$sessionsStorage.get("JOBSERIES");
      let ModuleID = this.$sessionsStorage.get("allModuleIdMain");
      this.validatedragfilesINVDetail();
      if (this.validateINV == false) {
        this.alert.content = "PLEASE Choose Files DETAILS.";
        this.$refs["addPop"].open();
        return false;
      }

      if(!this.nature_of_expense){
        this.alert.content = "PLEASE Choose Nature of Expense.";
        this.$refs["addPop"].open();
        return false;
      }

      if (this.validateINV != false) {
        let item_new = [];
        $("#addButtonLoaderSB").css("display", "none");
        $("#loaderSB").css("display", "block");
        let FileArr = this.singleUpload.split(",");
        FileArr.forEach((element) => {
          console.log("element=>", element);
          let obj = {
            documentName: "Other",
            otherDocName: element,
            documentLink: element,
            docRemarks: this.docRemark,
            addedFromMain: "5",
            allModuleId: ModuleID,
            assign_no: assign_no,
          };
          item_new.push(obj);
        });
        // console.log("item_new=>", item_new);
        // console.log("item_new=>", item_new);
        // return false;
        this.submitDocment(item_new, this.singleUpload);
        // this.onFileChangeExpense_Multiple_Doc(0, this.singleUpload);
      }
    },
    handleChange(v) {
      console.log("V files=>", v);
      this.files = [];
      // let files_arr = v.target.files || v.dataTransfer.files;
      // if(files_arr.length>0){
      //   this.files = files_arr;
      // }
      // alert(v.target.files.length, "v.target.files.length");
      // alert(v.dataTransfer.files.length, "v.dataTransfer.files.length");
      // console.log(v.target.files.length, "v.target.files.length");
      // console.log(v.dataTransfer.files.length, "v.dataTransfer.files.length");
      if (v.target.files.length > 0) {
        this.files = v.target.files;
      }
      if (v.dataTransfer.files.length > 0) {
        this.files = v.dataTransfer.files;
      }
      // console.log("files=>", v);
      console.log("files2=>", this.files);
      // this.files = v;
    },
    formatNames(v) {
      this.files = v.target.files;
      console.log("files=>", v);
      console.log("files2=>", this.files);
      return v.length === 1 ? v[0].name : `${v.length} files selected`;
    },
    // Drag And Drop Section Start
    onSelectVendor(index, items, vendor) {
      if (vendor == "00") {
        // this.lineInvModalArray[index].otherVendor= vendor;
        this.lineInvModalArray[index].otherVendorFlag = true;
      }
      // itm.vendor =
      // alert(vendor);
    },
    onSelectPaymentMode(event, item) {
      // console.log(event,item)
      // item.
      this.$forceUpdate();
    },
    onSelectPaymentStatus(event, item) {
      this.$forceUpdate();
    },
    onChoosePaymentDate(event, item) {
      this.$forceUpdate();
    },
    onChooseInvoiceDate(event, item) {
      this.$forceUpdate();
    },
    onSelectionChange(event) {
      console.log("Events= > ", event);
    },
    onSelect(index, items, lastSelectItem) {
      this.items = items;
      this.lastSelectItem = lastSelectItem;
      this.lineInvModalArray[index].invTypeArr = items;

      this.lineInvModalArray[index].invType = JSON.stringify(this.items);
      console.log(this.lineInvModalArray[index].invType);
    },
    // deselect option
    reset() {
      this.items = []; // reset
    },
    // select option from parent component
    selectFromParentComponent() {
      this.items = _.unionWith(this.items, [this.options[0]], _.isEqual);
      console.log("Item =>", this.items);
    },
    addInvArry() {
      console.log("Add invoice");

      let obj = {
        invId: "",
        exp_id: "",
        allModuleId: this.$sessionsStorage.get("allModuleIdMain"),
        invType: "",
        invNo: "",
        invAmount: "",
        invCurrency: "",
        invSlineUpload: "",
        invRemarks: "",
        vendor: "",
        otherVendor: "",
        otherVendorFlag: false,
        invDate: "",

        // invPayMode: {
        //   payVal: "1",
        //   payText: "RTGS",
        // },
        invPayMode: "",
        invPaidAmount: "",
        invPayRef: "",
        invPayDate: "",
        invPayStatus: "",

        invDate_err: "",
        vendor_err: "",
        invType_err: "",
        invNo_err: "",
        invAmount_err: "",
        invCurrency_err: "",
        invSlineUpload_err: "",

        invPayMode_err: "",
        invPaidAmount_err: "",
        invPayRef_err: "",
        invPayDate_err: "",
        invPayStatus_err: "",
      };
      this.lineInvModalArray.push(obj);

      console.log(this.lineInvModalArray.length);
    },

    RevisedAss(id) {
      // alert(id);
      var checkBox = document.getElementById(id).checked;
      console.log("Id => " + id + " : " + checkBox);
      if (checkBox) {
        (this.items = []), (this.lastSelectItem = {});
        for (let i = 0; i < lineInvModalArray.length; i++) {
          this.lineInvModalArray[i].invType = "";
          this.lineInvModalArray[i].invNo = "";
          this.lineInvModalArray[i].invAmount = "";
          this.lineInvModalArray[i].invCurrency = "";
          this.lineInvModalArray[i].invRemarks = "";
          this.lineInvModalArray[i].invSlineUpload = "";
          this.lineInvModalArray[i].invPayMode = "";
          this.lineInvModalArray[i].invPaidAmount = "";
          this.lineInvModalArray[i].invPayRef = "";
          this.lineInvModalArray[i].invPayDate = "";
          this.lineInvModalArray[i].invPayStatus = "";
        }
      }
    },

    addRevisedInvoice(index, id) {
      // alert(this.lineInvModalArray[index].invSlineUpload);
      var checkBox = document.getElementById(id).checked;
      // alert(checkBox);
      console.log("Id => " + id + " : " + checkBox);
      if (checkBox) {
        this.revisedInvoiceDetails.push(this.lineInvModalArray[index]);
        // alert(this.lineInvModalArray[index].invSlineUpload);
        this.lineInvModalArray[index].invSlineUpload = "";
        //  alert(this.lineInvModalArray[index].invSlineUpload);
        this.lineInvModalArray[index].invAmount = "";
      } else {
        this.revisedInvoiceDetails.splice(index, 1);
      }

      console.log("Revised mail => ", this.revisedInvoiceDetails);
    },

    removeInvArry(index) {
      this.lineInvModalArray.splice(index, 1);
    },

    getDueDate() {
      var date = new Date(this.INVDetail.sobDate);
      console.log(date);
      if (this.ImportDetail.shippingId == "15") {
        this.INVDetail.dueDate = date.setDate(date.getDate() + 9);
        this.INVDetail.dueDate = new Date(this.INVDetail.dueDate);
      } else if (this.ImportDetail.shippingId == "8") {
        this.INVDetail.dueDate = date.setDate(date.getDate() + 9);
        this.INVDetail.dueDate = new Date(this.INVDetail.dueDate);
      } else if (this.ImportDetail.shippingId == "13") {
        this.INVDetail.dueDate = date.setDate(date.getDate() + 9);
        this.INVDetail.dueDate = new Date(this.INVDetail.dueDate);
      } else if (this.ImportDetail.shippingId == "27") {
        this.INVDetail.dueDate = date.setDate(date.getDate() + 13);
        this.INVDetail.dueDate = new Date(this.INVDetail.dueDate);
      } else {
        this.INVDetail.dueDate = date.setDate(date.getDate() + 6);
        this.INVDetail.dueDate = new Date(this.INVDetail.dueDate);
      }
    },
    onFileChangeBlDraft(ID, index) {
      this.assign_no_series = this.$sessionsStorage.get("JOBSERIES");
      this.doc_path = this.assign_no_series.replaceAll("/", "_");
      // alert(this.doc_path);
      this.isLoading = true;
      let files = event.target.files || event.dataTransfer.files;
      let assign_no = this.$sessionsStorage.get("JOBSERIES");
      let ModuleID = this.$sessionsStorage.get("allModuleIdMain");
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);

        if (ID == "Sline_Invoice") {
          formData.append("staticFileName", "Expenses_Invoices_Doc_" + ModuleID);
        }

        formData.append(
          "upload_dir_folderName",
          // "CC_Sea_Import_Sline_Payments_Uploads"
          assign_no.replaceAll("/", "_")
        );
      }

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: ID + ModuleID,
        },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          this.lineInvModalArray[index].invSlineUpload = result.data;
          this.INVDetail.slineInvoice = result.data;
          console.log(this.INVDetail.slineInvoice);
          this.isLoading = false;
        })
        .catch((err) => {
          throw err;
        });
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    previousSalesView() {
      window.history.go(-1);
    },

    validateINVDetail() {
      let validate_new = true;
      let i = 0;
      let errCount = 0;
      let MainARR = this.lineInvModalArray;
      for (let j = 0; j < MainARR.length; j++) {
        // if (MainARR[j].vendor == "") {
        //   this.lineInvModalArray[j]["vendor_err"] = "Vendor Name Field is Required";
        //   validate_new = false;
        // ++errCount;
        // break;
        // } else {
        //   this.lineInvModalArray[j]["vendor_err"] = "";
        //   validate_new = true;
        // }
        // this.accounts = false;
        // alert(this.accounts);
        // alert(element.invPaidAmount);
        // this.accounts = false;
        // alert(this.accounts);

        if (this.accounts != false) {
          // alert(MainARR[j].invPaidAmount)
          if (MainARR[j].invPaidAmount != "") {
            // alert("Hello")
            if (MainARR[j].invPaidAmount == "") {
              this.lineInvModalArray[j]["invPaidAmount_err"] =
                "Payment Amount Field is Required";
              validate_new = false;
              ++errCount;
              break;
            } else {
              this.lineInvModalArray[j]["invPaidAmount_err"] = "";
              validate_new = true;
            }

            if (MainARR[j].invPayMode == "") {
              this.lineInvModalArray[j]["invPayMode_err"] =
                "Payment Mode Field is Required";
              validate_new = false;
              ++errCount;
              break;
            } else {
              this.lineInvModalArray[j]["invPayMode_err"] = "";
              validate_new = true;
            }

            if (MainARR[j].invPayRef == "") {
              this.lineInvModalArray[j]["invPayRef_err"] =
                "Payment Ref Field is Required";
              validate_new = false;
              ++errCount;
              break;
            } else {
              this.lineInvModalArray[j]["invPayRef_err"] = "";
              validate_new = true;
            }
            // alert(MainARR[j].invPayDate);
            if (MainARR[j].invPayDate == "") {
              this.lineInvModalArray[j]["invPayDate_err"] =
                "Payment Date Field is Required";
              validate_new = false;
              ++errCount;
              break;
            } else {
              this.lineInvModalArray[j]["invPayDate_err"] = "";
              validate_new = true;
            }

            if (MainARR[j].invPayStatus == "" || MainARR[j].invPayStatus == "0") {
              this.lineInvModalArray[j]["invPayStatus_err"] =
                "Payment Status Field is Required";
              validate_new = false;
              ++errCount;
              break;
            } else {
              this.lineInvModalArray[j]["invPayStatus_err"] = "";
              validate_new = true;
            }
          }
        } else if (this.accounts == false || this.role == "Admin") {
          // alert(MainARR[j].invDate)

          if (MainARR[j].invType == "") {
            this.lineInvModalArray[j]["invType_err"] = "Invoice Type Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["invType_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].invNo == "") {
            this.lineInvModalArray[j]["invNo_err"] = "Invoice NO Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["invNo_err"] = "";
            validate_new = true;
          }
          if (MainARR[j].invDate == "") {
            // alert("Hellow")
            this.lineInvModalArray[j]["invDate_err"] = "Invoice Date Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["invDate_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].invAmount == "") {
            this.lineInvModalArray[j]["invAmount_err"] =
              "Invoice Amount Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["invAmount_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].invCurrency == "") {
            this.lineInvModalArray[j]["invCurrency_err"] =
              "Invoice Currency Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["invCurrency_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].invSlineUpload == "") {
            this.lineInvModalArray[j]["invSlineUpload_err"] =
              "Invoice Document Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["invSlineUpload_err"] = "";
            validate_new = true;
          }
        }
      }
      // alert(errCount);
      // alert(validate_new);
      console.log("this.lineInvModalArray=>", this.lineInvModalArray);
      // return false;
      if (errCount > 0) {
        this.validateINV = false;
      }
      if (validate_new == false) {
        this.validateINV = false;
      } else {
        this.validateINV = true;
      }
    },
    viewEdit(id, index) {
      let array = this.containerTypeDetailFactory.filter((x) => {
        return x.ccExecutionContainerId == id;
      });

      Object.keys(this.ContainerTypeSizefactory).map((x) => {
        this.ContainerTypeSizefactory[x] = array[0][x];
      });
      this.showMoreSB = false;
    },

    checkInvNo() {
      return new Promise((resolve) => {
        (this.INVDetail["allModuleId"] = this.$sessionsStorage.get("allModuleIdMain")),
          (this.INVDetail.invoiceDetails = this.lineInvModalArray);
        if (this.lineInvModalArray.length > 0) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_Expenses/checkInvNoExist.php`,
            data: JSON.stringify(this.INVDetail),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                console.log(data);
                console.log(data.find);

                if (data.find == 1) {
                  this.invnoErrFlag = true;
                } else if (data.find == 2) {
                  this.invnoErrFlag = true;
                } else if (data.find == 0) {
                  this.invnoErrFlag = false;
                }

                this.syncFlag = true;
                console.log("Check");
                return resolve(!this.invnoErrFlag);
              }
            })
            .catch((error) => {});
        }
      });
    },

    async addINVDetail() {
      let array = this.lineInvModalArray;
      for (let i = 0; i < array.length; i++) {
        const element = array[i];
        if (element.exp_id == "") {
          let checkValueExit = await this.checkInvNo();
          console.log("checkValueExit", checkValueExit);

          if (!checkValueExit) {
            this.alert.content =
              "Payment request for one or more Expences invoices has already been raised to Accounts. Kindly check.";
            this.$refs["addPop"].open();
            return false;
          }
        }
      }
      // console.log("this.lineInvModalArray=>",this.lineInvModalArray);
      // return false;
      // alert(this.validateINV);
      this.validateINVDetail();
      if (this.validateINV == false) {
        this.alert.content = "PLEASE ENTER ALL DETAILS.";
        this.$refs["addPop"].open();
        return false;
      }
      // return false;
      // alert(this.validateINV);
      // if (this.validateINV == false) {
      //   return false;
      // }
      this.INVDetail["doc_path_series"] = this.doc_path;
      this.INVDetail["uploadArray"] = [];
      if (this.INVDetail.slineInvoice) {
        if (this.INVDetail.exp_id == "") {
          let i = 0;
          this.lineInvModalArray.forEach((element) => {
            let obj = {
              allModuleId: this.$sessionsStorage.get("allModuleIdMain"),
              docName:
                "Expenses_Invoice_" +
                this.$sessionsStorage.get("allModuleIdMain") +
                "_" +
                i,
              docLink: element["invSlineUpload"],
            };
            this.INVDetail.uploadArray.push(obj);
            i++;
          });
        } else if (this.INVDetail.exp_id != "") {
          let i = 0;
          this.lineInvModalArray.forEach((element) => {
            if (this.INVDetail.revisedMail != "1") {
              let obj = {
                allModuleId: this.$sessionsStorage.get("allModuleIdMain"),
                docName:
                  "Expenses_Invoice_" +
                  this.$sessionsStorage.get("allModuleIdMain") +
                  "_" +
                  i,
                docLink: element["invSlineUpload"],
              };
              this.INVDetail.uploadArray.push(obj);
            } else {
              let obj = {
                allModuleId: this.$sessionsStorage.get("allModuleIdMain"),
                docName:
                  "Expenses_Invoice_" +
                  this.$sessionsStorage.get("allModuleIdMain") +
                  "_" +
                  i,
                docLink: element["invSlineUpload"],
              };
              this.INVDetail.uploadArray.push(obj);
            }
            i++;
          });
        }
      }
      this.INVDetail.salesExeuctionNo = this.$sessionsStorage.get("JOBSERIES");
      this.INVDetail.allModuleId = this.$sessionsStorage.get("allModuleIdMain");

      this.INVDetail.invoiceDetails = this.lineInvModalArray;

      if (this.revisedInvoiceDetails.length > 0) {
        this.INVDetail.revisedInvoiceDetails = this.revisedInvoiceDetails;
      }
      console.log("After => ", this.INVDetail);
      // return false
      if (this.validateINV != false) {
        $("#addButtonLoaderSB").css("display", "none");
        $("#loaderSB").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Expenses/addExpenses.php`,
          data: JSON.stringify(this.INVDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200) {
              $("#loaderSB").css("display", "none");
              $("#addButtonLoaderSB").css("display", "block");
              window.history.go(-1);

              this.alert.content = data.msg;
              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {});
      }
    },
    vendorFilter(list, query) {
      return this.getVendorData.filter((x) => {
        return x.vendorName.toLowerCase().includes(query.toLowerCase());
      });
    },
    getData() {
      this.doLoading();

      let new_data = {
        allModuleId: this.$sessionsStorage.get("allModuleIdMain"),
        allModuleId: this.$sessionsStorage.get("allModuleIdMain"),
        exp_id: this.$sessionsStorage.get("exp_id"),
      };
      //   console.log(new_data);
      //   return false;
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Expenses/getInvoiceDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            console.log("MyDataArr=>", data);
            console.log("Priyanshu Singh=>", data.mainExpensesData);

            if (data.assignmentData.length > 0) {
              this.assignmentData = data.assignmentData;
            }
            if (data.ExpenseData.length > 0) {
              this.ExpenseData = data.ExpenseData;
            }
            if (data.mainExpensesData.length > 0) {
              Object.keys(this.lineInvModalArray).map((x) => {
                this.lineInvModalArray[x] = data.mainExpensesData[0][x] || "";
              });
              this.invDetailArray = data.mainExpensesData;

              let i = 0;
              data.mainExpensesData.forEach((element) => {
                var date = new Date(element.payDate);
                var result =
                  "" +
                  date.getFullYear() +
                  (date.getMonth() + 1 > 9 ? "-" : "-0") +
                  (date.getMonth() + 1) +
                  (date.getDate() > 9 ? "-" : "-0") +
                  date.getDate();
                var invPayDate = "";
                if (result == "1970-01-01") {
                  var invPayDate = "";
                } else {
                  var invPayDate = result;
                }

                var date2 = new Date(element.invDate);
                var result2 =
                  "" +
                  date2.getFullYear() +
                  (date2.getMonth() + 1 > 9 ? "-" : "-0") +
                  (date2.getMonth() + 1) +
                  (date2.getDate() > 9 ? "-" : "-0") +
                  date2.getDate();
                var invDate = "";
                if (result2 == "1970-01-01") {
                  var invDate = "";
                } else {
                  var invDate = result2;
                }
                this.INVDetail.exp_id = element.exp_id || "";
                element["invDate"] = invDate || "";
                element["vendor"] = element.vendor || "";
                element["otherVendor"] = element.otherVendor || "";
                element["exp_id"] = element.exp_id || "";
                element["allModuleId"] = element.allModuleId || "";
                element["invType"] = element.exp_type || "";
                element["invNo"] = element.invoice_no || "";
                element["invAmount"] = element.exp_amount || "";
                element["invCurrency"] = element.exp_Currency || "";
                element["invSlineUpload"] = element.exp_doc_link || "";
                element["invRemarks"] = element.exp_remarks || "";
                element["invPayMode"] = element.paymentMode || "";
                element["invPaidAmount"] = element.InvPaidAmount || "";
                element["invPayRef"] = element.payRefNumber || "";
                element["invPayDate"] = invPayDate || "";
                element["invPayStatus"] = element.InvPayStatus || "";
                // alert(element.vendor);
                if (element.vendor == "00") element["otherVendorFlag"] = true;
                else element["otherVendorFlag"] = false;

                // onSelectVendor(i,element,element.vendor)
                this.lineInvModalArray.push(element);
                i++;
              });
              this.INVDetail.revisedMail = 0;
            }

            if (data.Vendordetail.length > 0) {
              this.getVendorData = data.Vendordetail;
            } else {
              this.getVendorData = [];
            }
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },

    // JqueryFun() {
    //   return $(function() {
    //     return $("#ccContainer").DataTable();
    //   });
    // }
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// Expenses.vue?6541a123